import { render, staticRenderFns } from "./PulseOxCard.vue?vue&type=template&id=2328ad13&"
import script from "./PulseOxCard.vue?vue&type=script&lang=js&"
export * from "./PulseOxCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports